import { memo } from "react"
import { Handle, Position, Node, NodeProps } from "@xyflow/react"

type StatusNode = Node<{ status: string, label: string }, 'status'>;


export default memo(({ data }: NodeProps<StatusNode>) => {
    return (
        <div className={`flex flex-col bg-white min-w-[200px] justify-start items-start gap-1 py-1 px-2 rounded-lg border-2 ${data.status === 'success' ? 'border-[#008001]' : 'border-[#FF0000]'}`}>
            <Handle 
                type="target"
                position={Position.Left}
            />
            <p className="font-bold text-default">{data.label}</p>
            <div className="flex justify-start items-center gap-1">
                <div className={`w-[10px] aspect-square rounded ${data.status === 'success' ? 'bg-[#008001]' : 'bg-[#FF0000]'}`}></div>
                <p className="text-[12px] font-medium text-disable">{data.status}</p>
            </div>
            <Handle 
                type="source"
                position={Position.Right}
            />
        </div>
    )
})